import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { collection, query, where, onSnapshot, doc, setDoc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/config';
import { useAuth } from './AuthContext';

const BroadcastsContext = createContext(null);

export function BroadcastsProvider({ children }) {
  const { currentUser, effectiveRole } = useAuth();
  const [broadcasts,   setBroadcasts]   = useState([]);
  const [dismissedIds, setDismissedIds] = useState([]);

  useEffect(() => {
    if (!currentUser) return;
    const targetValues = effectiveRole ? ['all', effectiveRole] : ['all'];
    const q = query(collection(db, 'broadcasts'), where('target', 'in', targetValues));
    return onSnapshot(q,
      snap => setBroadcasts(snap.docs.map(d => ({ id: d.id, ...d.data() }))),
      err  => console.error('[BroadcastsContext] snapshot error:', err)
    );
  }, [currentUser, effectiveRole]);

  useEffect(() => {
    if (!currentUser) return;
    getDoc(doc(db, 'userBroadcastDismissals', currentUser.uid))
      .then(snap => { if (snap.exists()) setDismissedIds(snap.data().dismissedIds ?? []); })
      .catch(() => {});
  }, [currentUser]);

  const dismiss = useCallback(async (id) => {
    if (!currentUser) return;
    const newIds = [...dismissedIds, id];
    setDismissedIds(newIds);
    setDoc(doc(db, 'userBroadcastDismissals', currentUser.uid), { dismissedIds: newIds }, { merge: true })
      .catch(err => console.error('[BroadcastsContext] dismiss failed:', err));
  }, [currentUser, dismissedIds]);

  const undismissed     = broadcasts.filter(b => !dismissedIds.includes(b.id));
  const modalBroadcast  = currentUser ? (undismissed.find(b => b.displayMode === 'modal') ?? null) : null;
  const inboxBroadcasts = currentUser ? undismissed.filter(b => b.displayMode === 'inbox') : [];

  return (
    <BroadcastsContext.Provider value={{ modalBroadcast, inboxBroadcasts, dismiss }}>
      {children}
    </BroadcastsContext.Provider>
  );
}

export function useBroadcasts() {
  const ctx = useContext(BroadcastsContext);
  if (!ctx) throw new Error('useBroadcasts must be used inside BroadcastsProvider');
  return ctx;
}
